// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dYGIZ0qAd1pPuQfWvIBO{margin-left:8px}.UoVUN0QxiYH_j8g6YNoW{display:flex}`, "",{"version":3,"sources":["webpack://./src/pages/chatbot/ui/AgentKnowledgeBase/store/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,eAAA,CAGF,sBACE,YAAA","sourcesContent":[".iconCheckList {\n  margin-left: 8px;\n}\n\n.documentDropdownLabel {\n  display: flex;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"iconCheckList": `dYGIZ0qAd1pPuQfWvIBO`,
	"documentDropdownLabel": `UoVUN0QxiYH_j8g6YNoW`
};
export default ___CSS_LOADER_EXPORT___;
